import React from "react";
import { cn } from "@discovery/classnames";
import { ButtonPrev, ButtonNext } from "./styles";
export var NavDirection;
(function (NavDirection) {
    NavDirection["Prev"] = "Previous";
    NavDirection["Next"] = "Next";
})(NavDirection || (NavDirection = {}));
const ButtonWrapper = (props) => {
    switch (props.direction) {
        case NavDirection.Prev:
            return React.createElement(ButtonPrev, Object.assign({}, props));
        case NavDirection.Next:
            return React.createElement(ButtonNext, Object.assign({}, props));
    }
};
const TabbableNav = ({ className, onClick, tabIndex, direction, onMouseEnter, onMouseLeave, testId, disabled = false, ariaHidden, }) => {
    const ariaLabel = direction === NavDirection.Next ? "next" : "previous";
    return (React.createElement(ButtonWrapper, { direction: direction, onClick: onClick, className: cn(className), "aria-label": ariaLabel, tabIndex: tabIndex, onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave, "data-testid": testId, disabled: disabled, "aria-hidden": ariaHidden }));
};
export const GoToPrev = (props) => (React.createElement(TabbableNav, Object.assign({}, props, { direction: NavDirection.Prev })));
export const GoToNext = (props) => (React.createElement(TabbableNav, Object.assign({}, props, { direction: NavDirection.Next })));

